import { CurrencyChart } from "./CurrencyChart";
import KaiChatBtn from "./KAI/KaiChatBtn";
import Task from "./Task";

const SideDetails = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <KaiChatBtn />

        <button
          disabled
          className="bg-custom-blue-medium text-sm py-2 px-4 flex items-center gap-3 text-white font-medium rounded-2xl disabled:bg-custom-blue-medium/40 disabled:cursor-not-allowed"
        >
          Ongoing Orders
          <span className="size-6 bg-white text-custom-blue-medium flex items-center justify-center rounded-full">
            6
          </span>
        </button>
      </div>
      {/* <CurrencyChart /> */}
      <Task />
    </div>
  );
};

export default SideDetails;
